export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "Language": "de-DE",
    "Messages": {
        "Aby dodawać członków zespołu musisz najpierw zapisać formularz.": "Um Teammitglieder hinzuzufügen, müssen Sie zuerst das Formular speichern.",
        "Administracja": "Administration",
        "Adres": "Adresse",
        "Adres serwera katalogowego.": "Adresse des Verzeichnisservers.",
        "Adres, pod który panel wysyła powiadomienia.": "Adresse, an die das Panel Benachrichtigungen sendet.",
        "Aktywna": "Aktiv",
        "Aktywne źródła": "Aktive Quellen",
        "Aktywny": "Aktiv",
        "Anuluj": "Abbrechen",
        "bez prefiksu": "ohne Präfix",
        "Bezpieczeństwo": "Sicherheit",
        "Brak przypisanych użytkowników": "Keine Benutzer zugewiesen",
        "Brak wydziału": "Keine Abteilung",
        "Brak wyników": "Keine Ergebnisse",
        "Brak zdefiniowanych zespołów.": "Keine Teams definiert.",
        "Bramka SMS": "SMS-Gateway",
        "Ciemne tło": "Dunkler Hintergrund",
        "Ciemnoczerwona": "Dunkelrot",
        "Ciemnozielona": "Dunkelgrün",
        "Czerwiec": "Juni",
        "Członkowie zespołu": "Teammitglieder",
        "Data dodania": "Hinzufügedatum",
        "Data opuszczenia zespołu": "Datum des Austritts aus dem Team",
        "Data rozpoczęcia": "Startdatum",
        "Data utworzenia": "Erstellungsdatum",
        "Data użycia": "Verwendungsdatum",
        "Data wygaśnięcia": "Ablaufdatum",
        "Data zakończenia": "Enddatum",
        "dni": "Tage",
        "dnia": "Tag",
        "Do": "Bis",
        "Dodaj": "Hinzufügen",
        "Dodaj dział": "Abteilung hinzufügen",
        "Dodaj token": "Token hinzufügen",
        "Dodaj użytkownika": "Benutzer hinzufügen",
        "Dodaj użytkownika do zespołu": "Benutzer zum Team hinzufügen",
        "Dodaj użytkownika, korzystając z pola powyżej.": "Fügen Sie über das obige Feld einen Benutzer hinzu.",
        "Dodaj zastępstwo": "Vertretung hinzufügen",
        "Dodaj zespół": "Team hinzufügen",
        "Dodaj źródło": "Quelle hinzufügen",
        "Dodanie działu": "Abteilung hinzufügen",
        "Dodanie zastępstwa": "Vertretung hinzufügen",
        "Dodanie zespołu": "Team hinzufügen",
        "Dodanie źródła": "Quelle hinzufügen",
        "Dodatkowe informacje o zastępstwie": "Zusätzliche Informationen zur Vertretung",
        "Dokumentacja": "Dokumentation",
        "Domena": "Domäne",
        "Domena użytkowników źródła.": "Domäne der Benutzer der Quelle.",
        "Domyślna": "Standard",
        "Domyślnie 389, LDAPS 636.": "Standardmäßig 389, LDAPS 636.",
        "Dział aktywny": "Abteilung aktiv",
        "Dział nadrzędny": "Übergeordnete Abteilung",
        "Dział został dodany.": "Die Abteilung wurde hinzugefügt.",
        "Dział został usunięty.": "Die Abteilung wurde gelöscht.",
        "Dział został zaktualizowany.": "Die Abteilung wurde aktualisiert.",
        "Działy z katalogu zostaną odwzorowane jako grupy w panelu.": "Abteilungen aus dem Verzeichnis werden im Panel als Gruppen abgebildet.",
        "Edycja działu": "Abteilung bearbeiten",
        "Edycja i publikacja treści": "Inhalte bearbeiten und veröffentlichen",
        "Edycja zastępstwa": "Vertretung bearbeiten",
        "Edycja zespołu": "Team bearbeiten",
        "Edycja źródła": "Quelle bearbeiten",
        "Edytuj": "Bearbeiten",
        "Edytuj członka grupy": "Gruppenmitglied bearbeiten",
        "Edytuj wpis": "Eintrag bearbeiten",
        "Filtr działów": "Abteilungsfilter",
        "Filtr użytkowników": "Benutzerfilter",
        "Filtrowanie": "Filtern",
        "Filtruj członków zespołu": "Teammitglieder filtern",
        "Filtruj członków…": "Mitglieder filtern…",
        "Fioletowa": "Violett",
        "Firebase": "Firebase",
        "Firebase config": "Firebase-Konfiguration",
        "Format, w jakim użytkownik podaje login.": "Format, in dem der Benutzer den Login eingibt.",
        "Gotowe": "Fertig",
        "Grafitowa": "Anthrazit",
        "Grudzień": "Dezember",
        "Hasło": "Passwort",
        "Hasło konta usługowego.": "Passwort des Dienstkontos.",
        "Host": "Host",
        "Identyfikator nadawcy z konsoli Firebase.": "Absender-ID aus der Firebase-Konsole.",
        "Imię i nazwisko": "Vor- und Nachname",
        "Inspekcja": "Inspektion",
        "Integracja z Firebase": "Integration mit Firebase",
        "Integracja z Microsoft Teams": "Integration mit Microsoft Teams",
        "Integracja z platformą SMSAPI.pl": "Integration mit der SMSAPI.pl-Plattform",
        "Jasne tło": "Heller Hintergrund",
        "Jeśli użytkownika nie ma na liście, uzupełnij jego dane (Imię i Nazwisko) w dziale Użytkownicy.": "Wenn der Benutzer nicht in der Liste steht, ergänzen Sie seine Daten (Vor- und Nachname) im Bereich „Benutzer“.",
        "Jesteś programistą?": "Sind Sie Entwickler?",
        "Język": "Sprache",
        "Key": "Schlüssel",
        "Key pair": "Schlüsselpaar",
        "Kolor drugorzędny: %0": "Sekundärfarbe: %0",
        "Kolor icon na panelu z aplikacjami: %0": "Farbe des Symbols im Anwendungsbereich: %0",
        "Kolor podstawowy: %0": "Primärfarbe: %0",
        "Kolor tekstu aktywnej pozycji menu: %0": "Textfarbe des aktiven Menüeintrags: %0",
        "Kolor tła panelu z aplikacjami: %0": "Hintergrundfarbe des Anwendungsbereichs: %0",
        "Kolory zostały przywrócone.": "Die Farben wurden wiederhergestellt.",
        "Kolory zostały zapisane.": "Die Farben wurden gespeichert.",
        "Konfiguracja aplikacji web z konsoli Firebase.": "Konfiguration der Webanwendung aus der Firebase-Konsole.",
        "Koniec okresu zastępstwa.": "Ende des Vertretungszeitraums.",
        "Konta użytkowników zostały przypisane do zespołu": "Benutzerkonten wurden dem Team zugewiesen",
        "Konto": "Konto",
        "Konto do odpytywania katalogu.": "Konto für die Verzeichnisabfrage.",
        "Konto usługowe": "Dienstkonto",
        "Kopiuj": "Kopieren",
        "Krótki opis zespołu": "Kurzbeschreibung des Teams",
        "Kto i kogo zastępuje w wybranym okresie.": "Wer wen im ausgewählten Zeitraum vertritt.",
        "Kwiecień": "April",
        "LDAPS (LDAP over SSL)": "LDAPS (LDAP über SSL)",
        "Liczba wyników": "Anzahl der Ergebnisse",
        "Lider": "Leiter",
        "Lipiec": "Juli",
        "Listopad": "November",
        "Login": "Anmeldename",
        "Luty": "Februar",
        "Maj": "Mai",
        "Maks. 11 znaków, bez polskich liter.": "Max. 11 Zeichen, keine polnischen Buchstaben.",
        "Marzec": "März",
        "Microsoft Teams": "Microsoft Teams",
        "Miesiąc": "Monat",
        "Moje konto": "Mein Konto",
        "Możliwość modyfikacji tego działu jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "Die Möglichkeit, diesen Bereich zu bearbeiten, ist eingeschränkt. Inaktive Felder werden mit der externen Datenbank %0 synchronisiert.",
        "Nadawca": "Absender",
        "Nazwa": "Name",
        "Nazwa działu": "Bereichsname",
        "Nazwa na liście źródeł.": "Name in der Quellenliste.",
        "Nazwa użytkownika": "Benutzername",
        "Nazwa zespołu": "Teamname",
        "Nazwa źródła": "Quellenname",
        "Nie": "Nein",
        "Nie masz dostępu do tego modułu": "Sie haben keinen Zugriff auf dieses Modul",
        "Nie udało się pobrać listy działów": "Die Bereichsliste konnte nicht abgerufen werden",
        "Nie udało się pobrać listy ról": "Die Rollenliste konnte nicht abgerufen werden",
        "Nie udało się pobrać listy wydziałów": "Die Abteilungsliste konnte nicht abgerufen werden",
        "Nie udało się pobrać listy zespołów": "Die Teamliste konnte nicht abgerufen werden",
        "Nie udało się pobrać projektu MCP. Spróbuj ponownie.": "Das MCP-Projekt konnte nicht abgerufen werden. Versuchen Sie es erneut.",
        "Nie udało się pobrać tokenów": "Die Token konnten nicht abgerufen werden",
        "Nie udało się wczytać członków zespołu": "Die Teammitglieder konnten nicht geladen werden",
        "Nie udało się wczytać działu": "Der Bereich konnte nicht geladen werden",
        "Nie zdefiniowano żadnych ról.": "Es wurden keine Rollen definiert.",
        "Nieaktywna": "Inaktiv",
        "nieaktywne": "inaktiv",
        "Nieaktywne źródło nie bierze udziału w logowaniu.": "Eine inaktive Quelle wird bei der Anmeldung nicht berücksichtigt.",
        "Niebieska": "Blau",
        "Nowy token dostępu": "Neues Zugriffstoken",
        "np. AD Warszawa": "z. B. AD Warschau",
        "np. Redaktorzy": "z. B. Redakteure",
        "Od": "Von",
        "Okres i szczegóły": "Zeitraum und Details",
        "Określ indywidualne uprawnienia przypisane do zespołu.": "Legen Sie individuelle Berechtigungen für das Team fest.",
        "Opcje": "Optionen",
        "Opcjonalna informacja wyjaśniająca zakres zastępstwa.": "Optionale Information zur Erläuterung des Umfangs der Vertretung.",
        "Opcjonalnie opisz zadania lub przeznaczenie zespołu.": "Beschreiben Sie optional die Aufgaben oder den Zweck des Teams.",
        "Opis": "Beschreibung",
        "Opis zespołu": "Team-Beschreibung",
        "Organizacja": "Organisation",
        "Organizacja została usunięta.": "Die Organisation wurde gelöscht.",
        "Osoba zastępowana": "Vertretene Person",
        "Osoba zastępująca": "Vertretende Person",
        "Osoby": "Personen",
        "Paleta kolorów": "Farbpalette",
        "Panel może przekazywać powiadomienia do wskazanego kanału. Uzupełnij dane otrzymane od administratora Microsoft Teams.": "Das Panel kann Benachrichtigungen an den angegebenen Kanal weiterleiten. Geben Sie die von Ihrem Microsoft-Teams-Administrator erhaltenen Daten ein.",
        "Panel wysyła powiadomienia push przez projekt Firebase. Po zmianie danych wcześniejsze urządzenia mogą wymagać ponownej rejestracji.": "Das Panel sendet Push-Benachrichtigungen über ein Firebase-Projekt. Nach einer Änderung der Daten müssen frühere Geräte möglicherweise erneut registriert werden.",
        "Październik": "Oktober",
        "Pełny dostęp do systemu": "Vollzugriff auf das System",
        "Plik konta usługowego w formacie JSON.": "Dienstkontodatei im JSON-Format.",
        "Pobierz projekt dla Claude Code": "Projekt für Claude Code herunterladen",
        "Pobierz projekt dla Codexa": "Projekt für Codex herunterladen",
        "Pobierz starter teraz – po zamknięciu tego widoku pełny token nie będzie ponownie dostępny.": "Starter jetzt herunterladen – nach dem Schließen dieser Ansicht ist das vollständige Token nicht mehr verfügbar.",
        "Początek okresu zastępstwa.": "Beginn des Vertretungszeitraums.",
        "Podaj nazwę, która pozwoli łatwo rozpoznać zespół.": "Geben Sie einen Namen ein, anhand dessen sich das Team leicht erkennen lässt.",
        "Pokaż": "Anzeigen",
        "Pokaż hasło": "Passwort anzeigen",
        "Pokaż token": "Token anzeigen",
        "Połącz Edito z asystentem AI": "Edito mit dem KI-Assistenten verbinden",
        "Połączenie szyfrowane - port zwykle 636.": "Verschlüsselte Verbindung – Port normalerweise 636.",
        "Połączenie z MCP — instrukcja": "Verbindung mit MCP – Anleitung",
        "Pole \"Liczba wyników\" jest wymagane.": "Das Feld „Anzahl der Ergebnisse“ ist erforderlich.",
        "Pole \"Nadawca\" jest wymagane.": "Das Feld „Absender“ ist erforderlich.",
        "Pole \"Testowy numer telefonu\" jest wymagane.": "Das Feld „Testtelefonnummer“ ist erforderlich.",
        "Pole \"Token\" jest wymagane.": "Das Feld „Token“ ist erforderlich.",
        "Popraw błędy formularza przed zapisaniem.": "Beheben Sie die Formularfehler, bevor Sie speichern.",
        "Port": "Port",
        "Potwierdzenie rotacji tokenu": "Bestätigung der Token-Rotation",
        "Potwierdzenie usunięcia": "Löschbestätigung",
        "Pozostaw puste, aby nie zmieniać.": "Leer lassen, um keine Änderung vorzunehmen.",
        "Pozostaw puste, aby utworzyć token bezterminowy. Maksymalny okres ważności wynosi 365 dni.": "Leer lassen, um ein Token ohne Ablaufdatum zu erstellen. Die maximale Gültigkeitsdauer beträgt 365 Tage.",
        "Predefiniowane tła panelu z aplikacjami": "Vordefinierte Hintergründe des Anwendungsbereichs",
        "Predefiniowane zestawy kolorów": "Vordefinierte Farbpaletten",
        "Projekt został pobrany. Rozpakuj go, utwórz nowy projekt w wybranym programie i wskaż rozpakowany folder.": "Das Projekt wurde heruntergeladen. Entpacken Sie es, erstellen Sie ein neues Projekt im gewünschten Programm und wählen Sie den entpackten Ordner aus.",
        "Przetestuj ustawienia SMS": "SMS-Einstellungen testen",
        "Przykład: domena\\użytkownik": "Beispiel: Domäne\\Benutzer",
        "Przykład: użytkownik": "Beispiel: Benutzer",
        "Przykład: użytkownik@domena": "Beispiel: Benutzer@Domäne",
        "Przypisanie do zespołu": "Teamzuweisung",
        "Przywróć domyślne": "Auf Standard zurücksetzen",
        "Publiczny klucz VAPID aplikacji web.": "Öffentlicher VAPID-Schlüssel der Webanwendung.",
        "Puste pole oznacza wartość domyślną: (&(objectClass=organizationalUnit)).": "Ein leeres Feld bedeutet den Standardwert: (&(objectClass=organizationalUnit)).",
        "Puste pole oznacza wartość domyślną: (&(objectClass=user)).": "Ein leeres Feld bedeutet den Standardwert: (&(objectClass=user)).",
        "Rok": "Jahr",
        "Role i uprawnienia": "Rollen und Berechtigungen",
        "Role zespołu": "Teamrollen",
        "Root": "Root",
        "Rotuj": "Rotieren",
        "Sekcje użytkownika": "Benutzerbereiche",
        "SenderId": "SenderId",
        "Serwer": "Server",
        "Sierpień": "August",
        "Skonfiguruj połączenie standardowo w repozytorium – zarówno dla Codexa, jak i Claude Code użyj lokalnego pliku": "Richten Sie die Verbindung standardmäßig im Repository ein – verwenden Sie sowohl für Codex als auch für Claude Code eine lokale Datei.",
        "Skopiowano": "Kopiert",
        "Spróbuj ponownie": "Erneut versuchen",
        "Strona główna": "Startseite",
        "Styczeń": "Januar",
        "Synchronizacja": "Synchronisierung",
        "System": "System",
        "Szukaj po nazwie…": "Nach Name suchen…",
        "Ta opcja jest przeznaczona dla redaktorów i użytkowników nietechnicznych. Wybierz program, z którego korzystasz.": "Diese Option ist für Redakteure und nichttechnische Benutzer vorgesehen. Wählen Sie das Programm aus, das Sie verwenden.",
        "Tak": "Ja",
        "Testowy numer telefonu": "Testtelefonnummer",
        "Token": "Token",
        "Token OAuth z panelu SMSAPI. Przechowujemy go zaszyfrowany.": "OAuth-Token aus dem SMSAPI-Panel. Wir speichern es verschlüsselt.",
        "Token przechowuj wyłącznie w tym ignorowanym przez Git pliku.": "Speichern Sie das Token ausschließlich in dieser von Git ignorierten Datei.",
        "Token utworzony": "Token erstellt",
        "Token został usunięty.": "Das Token wurde gelöscht.",
        "Token został zrotowany.": "Das Token wurde rotiert.",
        "Tokeny": "Token",
        "Tokeny dostępu": "Zugriffstoken",
        "Tokeny zostały usunięte.": "Die Token wurden gelöscht.",
        "Twój token": "Ihr Token",
        "Tworzenie i edycja wpisów": "Einträge erstellen und bearbeiten",
        "Tylko liderzy": "Nur Teamleiter",
        "Typ logowania": "Anmeldetyp",
        "Ukryj": "Ausblenden",
        "Ukryj hasło": "Passwort ausblenden",
        "Ukryj token": "Token ausblenden",
        "Uprawnienia": "Berechtigungen",
        "Uprawnienia zespołu": "Team-Berechtigungen",
        "Ustal początek i koniec zastępstwa. Opcjonalnie dodaj opis jego zakresu.": "Legen Sie Anfang und Ende der Vertretung fest. Optional können Sie eine Beschreibung des Umfangs hinzufügen.",
        "Ustawienia": "Einstellungen",
        "Ustawienia zostały zapisane.": "Die Einstellungen wurden gespeichert.",
        "Usuń": "Löschen",
        "Usuń dział": "Abteilung löschen",
        "Usuń z zespołu": "Aus dem Team entfernen",
        "Utwórz grupy": "Gruppen erstellen",
        "Utwórz token": "Token erstellen",
        "Uwzględnij wydziały podrzędne": "Untergeordnete Abteilungen einbeziehen",
        "Uzupełnij wymagane pola przed testem.": "Füllen Sie die erforderlichen Felder vor dem Test aus.",
        "Użytkownicy": "Benutzer",
        "Użytkownik": "Benutzer",
        "Użytkownik dodany": "Benutzer hinzugefügt",
        "Użytkownik dodany do zespołu": "Benutzer zum Team hinzugefügt",
        "Użytkownik jest liderem zespołu": "Der Benutzer ist Teamleiter",
        "Użytkownik nie należy do żadnego zespołu.": "Der Benutzer gehört keinem Team an.",
        "Użytkownik został dodany do zespołu.": "Der Benutzer wurde zum Team hinzugefügt.",
        "Użytkownik został usunięty z zespołu.": "Der Benutzer wurde aus dem Team entfernt.",
        "W organizacji nie ma jeszcze żadnych działów.": "In der Organisation gibt es noch keine Abteilungen.",
        "W zespole": "Im Team",
        "W zespole od %0 %1": "Im Team seit %0 %1",
        "Wczytywanie": "Wird geladen",
        "Węzeł startowy wyszukiwania.": "Startknoten der Suche.",
        "Wiadomość testowa została wysłana.": "Die Testnachricht wurde gesendet.",
        "Wiadomości wychodzą przez konto SMSAPI - token wygenerujesz w panelu platformy w sekcji „Ustawienia → API”. Nazwa nadawcy musi być zatwierdzona przez operatora, inaczej SMS-y wyjdą z pola nadawcy „Info”.": "Nachrichten werden über ein SMSAPI-Konto versendet – das Token können Sie im Plattform-Panel unter „Einstellungen → API“ generieren. Der Absendername muss vom Anbieter genehmigt werden, andernfalls werden SMS mit dem Absender „Info“ versendet.",
        "Włącz, jeśli zespół jest obecnie używany.": "Aktivieren Sie diese Option, wenn das Team derzeit verwendet wird.",
        "Wpis został zaktualizowany.": "Der Eintrag wurde aktualisiert.",
        "Wrzesień": "September",
        "Wybierz opcję": "Option auswählen",
        "Wybierz role określające uprawnienia zespołu.": "Wählen Sie die Rollen aus, die die Berechtigungen des Teams festlegen.",
        "Wybierz użytkownika…": "Benutzer auswählen…",
        "Wybierz użytkowników dla których chcesz wykonać akcje": "Wählen Sie die Benutzer aus, für die Sie Aktionen ausführen möchten",
        "Wydział": "Abteilung",
        "Wydział organizacji, do którego przypisany jest użytkownik.": "Abteilung der Organisation, der der Benutzer zugeordnet ist.",
        "wygasł": "abgelaufen",
        "Wypełnij, jeśli połączenie wymaga autoryzacji.": "Füllen Sie dieses Feld aus, wenn für die Verbindung eine Authentifizierung erforderlich ist.",
        "Wyślemy jednego SMS-a testowego na podany numer - koszt zgodnie z cennikiem operatora.": "Wir senden eine Test-SMS an die angegebene Nummer – die Kosten richten sich nach der Preisliste des Anbieters.",
        "Zablokowany": "Gesperrt",
        "Zacznij pisać, aby wyszukać użytkownika…": "Beginnen Sie zu tippen, um nach einem Benutzer zu suchen…",
        "Zamknij": "Schließen",
        "Zapisz": "Speichern",
        "Zapisz i wróć": "Speichern und zurück",
        "Zastępstwa": "Vertretungen",
        "Zastępstwo wygasło.": "Die Vertretung ist abgelaufen.",
        "Zastępstwo wygaśnie za 10 minut.": "Die Vertretung läuft in 10 Minuten ab.",
        "Zastępstwo wygaśnie za 5 minut.": "Die Vertretung läuft in 5 Minuten ab.",
        "Zastępstwo wygaśnie za minutę.": "Die Vertretung läuft in einer Minute ab.",
        "Zastępstwo zostało dodane.": "Die Vertretung wurde hinzugefügt.",
        "Zastępstwo zostało usunięte.": "Die Vertretung wurde gelöscht.",
        "Zastępstwo zostało zaktualizowane.": "Die Vertretung wurde aktualisiert.",
        "Zastępuje": "Vertritt",
        "Zastępuje osobę": "Vertritt eine Person",
        "Zawiera": "Enthält",
        "Zaznacz pole obok, aby ustawić lub zmienić hasło.": "Markieren Sie das Kontrollkästchen daneben, um ein Passwort festzulegen oder zu ändern.",
        "Zespół": "Team",
        "Zespół aktywny": "Team aktiv",
        "Zespół został dodany.": "Das Team wurde hinzugefügt.",
        "Zespół został usunięty.": "Das Team wurde gelöscht.",
        "Zespół został zaktualizowany.": "Das Team wurde aktualisiert.",
        "Zespoły": "Teams",
        "Zmień filtrowanie, aby zobaczyć członków zespołu.": "Ändern Sie den Filter, um Teammitglieder anzuzeigen.",
        "Zmień hasło": "Passwort ändern",
        "Źródła LDAP": "LDAP-Quellen",
        "Źródło aktywne": "Quelle aktiv",
        "Źródło LDAP zostało dodane.": "Die LDAP-Quelle wurde hinzugefügt.",
        "Źródło LDAP zostało zaktualizowane.": "Die LDAP-Quelle wurde aktualisiert.",
        "Źródło zostało usunięte.": "Die Quelle wurde gelöscht."
    }
};
